<template>
    <div class="row">
        <div class="col-12 col-md-6 col-lg-5 form-group">
          <label :for="id">{{ label }} *<br></label>
          <div class="input-group mb-3">
            <input :type="passwordOne.fieldType" :name="fieldName ? fieldName : 'consumer[password]'" :id="id"
                   dusk="passwd"
                   :class="passwordOne.class + ' input-with-addon'"
                   :placeholder="$t('vue.checkout.pages.fromRegister.password')" :aria-label="label"
                   :aria-describedby="'pw_button_one'" v-model="passwordOne.value"
                   v-on:keyup="checkPassword(); checkPasswordConfirmation()">
            <div class="input-group-append" tabindex="-1" @click="toggleVisibilityOne">
                    <span class="btn btn-outline-secondary"
                          :id="'pw_button_one'"><i class="far"
                                                   :class="passwordOne.fieldType === 'text' ? 'fa-eye-slash' : 'fa-eye'"
                                                   tabindex="-1"></i></span>
                </div>
            </div>
            <div class="row">
                <div v-for="(validation, index) in validations" class="col-12">
                    <small v-if="validation.status" class="text-success">
                        <i :class="icons.correct"></i>
                        {{ validation.text}}
                    </small>
                    <small v-else>
                        <i :class="icons.wrong"></i>
                        {{ validation.text}}
                    </small>
                </div>
            </div>
        </div>
      <div class="col-12 col-md-5 col-lg-5 form-group">
        <label :for="id">{{ $t('vue.checkout.pages.fromRegister.repeatPassword') }} *</label>
        <div class="input-group mb-3">
          <input :type="passwordTwo.fieldType"
                 :name="confirmationFieldName ? confirmationFieldName : 'consumer[password_confirmation]'"
                 dusk="passwd_confirmation"
                 :id="id+'_confirmation'"
                 :class="passwordTwo.class + ' input-with-addon'"
                 :placeholder="$t('vue.checkout.pages.fromRegister.password')" :aria-label="label"
                 :aria-describedby="'pw_button_two'" v-model="passwordTwo.value"
                 v-on:keyup="checkPassword(); checkPasswordConfirmation()">
                <div class="input-group-append" @click="toggleVisibilityTwo">
                    <span class="btn btn-outline-secondary"
                          :id="'pw_button_two'"><i class="far"
                                                   :class="passwordTwo.fieldType === 'text' ? 'fa-eye-slash' : 'fa-eye'"
                                                   tabindex="-1"></i></span>
                </div>
            </div>
            <small v-if="samePasswords.status" class="text-success">
                <i :class="icons.correct"></i>
                {{ samePasswords.text}}
            </small>
            <small v-else>
                <i :class="icons.wrong"></i>
                {{ samePasswords.text}}
            </small>
        </div>
    </div>
</template>

<script>
    export default {
        name: "PasswordField",
        props: ['name', 'id', 'label', 'fieldName', 'confirmationFieldName'],
        data() {
            return {
                passwordOne: {
                    value: "",
                    fieldType: 'password',
                    class: 'form-control'
                },
                passwordTwo: {
                    value: "",
                    fieldType: 'password',
                    class: 'form-control'
                },
                icons: {
                    wrong: 'fas fa-times',
                    correct: 'fas fa-check'
                },
                samePasswords: {
                    text: this.$t('vue.checkout.pages.fromRegister.passwordsSame'),
                    status: false
                },
                validations: {
                    minSigns: {
                        text: this.$t('vue.checkout.pages.fromRegister.minCharacter'),
                        status: false
                    },
                    minOneNUmber: {
                        text: this.$t('vue.checkout.pages.fromRegister.minNumber'),
                        status: false
                    },
                    lowerAndUppercase: {
                      text: this.$t('vue.checkout.pages.fromRegister.letters'),
                      status: false
                    },
                    minOneSPeacial: {
                        text: this.$t('vue.checkout.pages.fromRegister.minSpecialCharacter'),
                        status: false
                    }
                }
            };
        },
        methods: {


            toggleVisibilityOne() {
                this.passwordOne.fieldType = this.passwordOne.fieldType === "password" ? "text" : "password";
            },
            toggleVisibilityTwo() {
                this.passwordTwo.fieldType = this.passwordTwo.fieldType === "password" ? "text" : "password";
            },
            checkPassword() {
                this.validations.minSigns.status = !!this.minLength();
                this.validations.minOneNUmber.status = !!this.minOneNumber();
                this.validations.lowerAndUppercase.status = !!this.lowerAndUppercase();
                this.validations.minOneSPeacial.status = !!this.containsSpecialChars();
                this.passwordOne.class = this.areSamePasswords() ? "form-control is-valid" : "form-control is-invalid";
                this.passwordTwo.class = this.areSamePasswords() ? "form-control is-valid" : "form-control is-invalid";
                this.$emit('update:password', this.passwordOne.value);
                this.finalCheck();
            },
            checkPasswordConfirmation() {
                this.samePasswords.status = this.areSamePasswords();
                this.passwordOne.class = this.areSamePasswords() ? "form-control is-valid" : "form-control is-invalid";
                this.passwordTwo.class = this.areSamePasswords() ? "form-control is-valid" : "form-control is-invalid";
                this.$emit('update:password-confirmation', this.passwordTwo.value);
                this.finalCheck();
            },
            minLength() {
                return this.passwordOne.value.length >= 8;
            },
            minOneNumber() {
                return /\d/.test(this.passwordOne.value);
            },
            lowerAndUppercase() {
                return this.passwordOne.value.match(/[a-z]/) && this.passwordOne.value.match(/[A-Z]/);
            },
            containsSpecialChars() {
                let expression = /^(?=.*[!@#$%^&?*+=._-]).+$/;
                return expression.test(this.passwordOne.value);
            },
            areSamePasswords() {
                return this.passwordOne.value === this.passwordTwo.value;
            },
            finalCheck() {
                if (this.areSamePasswords() && this.validations.minOneSPeacial.status && this.validations.lowerAndUppercase.status && this.validations.minSigns.status && this.validations.minOneNUmber.status) {
                    this.passwordOne.class = "form-control is-valid";
                    this.passwordTwo.class = "form-control is-valid";
                    this.$emit('password-is-valid');
                } else {
                    this.passwordOne.class = "form-control is-invalid";
                    this.passwordTwo.class = "form-control is-invalid";
                    this.$emit('password-is-invalid');
                }
            }
        }
    }
</script>

<style scoped type="text/scss">
    .btn-outline-secondary {
        border-color: rgb(140, 140, 140);
        border-left: none;
    }

    .input-with-addon {
        border-right: none;
    }
</style>
